module.exports = __webpack_public_path__ + "static/media/asyst-besar.fef0ddec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/asyst/asyst-besar.png
// module id = 835
// module chunks = 0